import type { CSSProperties, ReactNode } from 'react';

interface MonoLabelProps {
  children: ReactNode;
  color?: string;
  className?: string;
}

export function MonoLabel({ children, color, className = '' }: MonoLabelProps) {
  const style: CSSProperties = color ? { color } : {};
  return (
    <div
      style={style}
      className={['mono-caps whitespace-nowrap', !color && 'text-muted', className]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </div>
  );
}
